// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1406":"801481e9","2529":"0b54251e","4630":"7a035314","7528":"ee0381ec","8375":"0b54251e"}[chunkId] + ".chunk.css";
};